import { atom } from 'jotai';
import { getMapDefaultConfig } from 'components/map/atoms';

export const mapConfigAtom = atom(
  getMapDefaultConfig({
    // Smooth scroll-to-zoom on by default (users can still toggle it off).
    scrollZoom: {
      checked: true,
    },
    wellsV2: {
      checked: false,
      options: {
        surfaceHole: false,
        bottomHole: false,
        stick: false,
        survey: false,
        vertical: false,
        horizontal: false,
        horizontalPermit: false,
        horizontalDuc: false,
        horizontalProducing: false,
        horizontalShutIn: false,
        horizontalExpiredPermit: false,
        horizontalInactive: false,
        horizontalPrePermit: false,
        horizontalApd: false,
        horizontalProposal: false,
        horizontalPlanned: false,
        verticalPermit: false,
        verticalDuc: false,
        verticalProducing: false,
        verticalShutIn: false,
        verticalExpiredPermit: false,
        verticalInactive: false,
        verticalPrePermit: false,
        verticalApd: false,
        verticalProposal: false,
        verticalPlanned: false,
        permit: false,
        duc: false,
        producing: false,
        shutIn: false,
        expiredPermit: false,
        inactive: false,
        prePermit: false,
        apd: false,
        proposal: false,
        planned: false,
      },
    },
    wells: {
      checked: false,
      options: {
        surfaceHole: false,
        bottomHole: false,
        stick: false,
        survey: false,
        vertical: false,
      },
    },
    developmentAreas: {
      checked: false,
      options: {
        horizontalUnits: false,
        verticalUnits: false,
        fieldUnits: false,
        pricing: false,
      },
    },
    basinTier: {
      checked: false,
      options: {
        basin: false,
        tier: false,
      },
    },
    titleEntityAssets: {
      checked: false,
      options: {
        surfaceInterest: false,
        workingInterest: false,
        unleased: false,
        royaltyInterest: false,
      },
    },
    // Default-on for Portfolio Assets tract polygons. In map-query, actual
    // visibility is driven by the dataset toggle via MapSection's
    // `portfolioAssetsVisible` override, so this flag only sets the baseline.
    portfolioAssets: {
      checked: true,
    },
    focusAreas: {
      checked: false,
      selections: {},
    },
    pipelines: {
      checked: false,
      options: {
        gasOperating: false,
        gasUnderConstruction: false,
        gasPlannedOther: false,
        oilOperating: false,
        oilUnderConstruction: false,
        oilPlannedOther: false,
        productOperating: false,
        productConstruction: false,
        productPlannedOther: false,
        unknownOperating: false,
        unknownUnderConstruction: false,
        unknownPlannedOther: false,
      },
    },
    drillingRigs: {
      checked: false,
      options: {
        horizontalDrilling: false,
        horizontalDown: false,
        horizontalNotReporting: false,
        horizontalNotTracking: false,
        horizontalUnreportedStatus: false,
        verticalDrilling: false,
        verticalDown: false,
        verticalNotReporting: false,
        verticalNotTracking: false,
        verticalUnreportedStatus: false,
      },
    },
  })
);

export const DEFAULT_LAT = 33.0;
export const DEFAULT_LNG = -100.0;
export const DEFAULT_ZOOM = 4;
